import React from 'react';
import './About.css';
import GlobeTech from '../assets/images/globe-tech.png';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="hakkinda" className="about-section">
      <div className="section-header">
        <div className="section-badge">
          <i className="fa-solid fa-lightbulb"></i>
          <span>{t('about.badge')}</span>
        </div>
        <h2 className="section-title">{t('about.title')}</h2>
        <p className="section-subtitle">{t('about.subtitle')}</p>
      </div>

      <div className="about-grid">
        <div className="about-main-card">
          <div className="card-decor-glow"></div>
          
          <div className="about-visual-banner">
            <img src={GlobeTech} alt="Akinevo Global Network" className="about-globe-img" />
            <div className="banner-overlay">
              <span className="overlay-tag">
                <i className="fa-solid fa-network-wired"></i> {t('about.visionTag')}
              </span>
            </div>
          </div>

          <h3>{t('about.mainTitle')}</h3>
          <p>{t('about.p1')}</p>
          <p>{t('about.p2')}</p>
          <p>{t('about.p3')}</p>

          <div className="values-list">
            <div className="value-pill">
              <i className="fa-solid fa-check-double"></i>
              <span>{t('about.v1')}</span>
            </div>
            <div className="value-pill">
              <i className="fa-solid fa-gem"></i>
              <span>{t('about.v2')}</span>
            </div>
            <div className="value-pill">
              <i className="fa-solid fa-rocket"></i>
              <span>{t('about.v3')}</span>
            </div>
            <div className="value-pill">
              <i className="fa-solid fa-users"></i>
              <span>{t('about.v4')}</span>
            </div>
          </div>
        </div>

        <div className="about-side-cards">
          <div className="side-card">
            <div className="side-card-icon">
              <i className="fa-solid fa-code"></i>
            </div>
            <h4>{t('about.side1Title')}</h4>
            <p>{t('about.side1Desc')}</p>
          </div>

          <div className="side-card">
            <div className="side-card-icon">
              <i className="fa-solid fa-heart-pulse"></i>
            </div>
            <h4>{t('about.side2Title')}</h4>
            <p>{t('about.side2Desc')}</p>
          </div>

          <div className="side-card">
            <div className="side-card-icon">
              <i className="fa-solid fa-handshake-angle"></i>
            </div>
            <h4>{t('about.side3Title')}</h4>
            <p>{t('about.side3Desc')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
